import type { IconName, IconSize } from '@freelancer/ui/icon';
import type { FontWeight } from '@freelancer/ui/text';

export interface SocialUrls {
  facebook?: string;
  x?: string;
  youtube?: string;
  instagram?: string;
  linkedin?: string;
  pinterest?: string;
}

export enum SocialButtonColor {
  LIGHT = 'light',
  DARK = 'dark',
  COLORED = 'colored',
  FOREGROUND = 'foreground',
}

export enum SocialButtonType {
  ICON = 'icon',
  BUTTON = 'button',
}

export type SocialButtonSize = IconSize.SMALL | IconSize.MID | IconSize.LARGE;

export type SocialPlatform =
  | 'facebook'
  | 'x'
  | 'youtube'
  | 'instagram'
  | 'linkedin'
  | 'pinterest'
  | 'copyLink';

export interface SocialPlatformConfig {
  readonly key: SocialPlatform;
  readonly icon: IconName;
  readonly shareLabel: string;
  readonly linkLabel: string;
  readonly mode: 'shareOnly' | 'linkOnly' | 'both';
  readonly useIconFont?: boolean;
  readonly fillIconFont?: boolean;
  readonly weight?: FontWeight;
  readonly tooltip?: string;
  readonly lightThemeColorOverride?: boolean;
}
